//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {appBaseUrl} from "../../utils/commons";
export default {
  name: "to-do",
  data() {
    return {
      todoList: [],
      iconList:[
        'bar-chart',
        'file-text',
        'printer',
        'pay-circle',
        'schedule'
      ]
    }
  },
  methods: {
    getUserType() {
      this.$loadingShow();
      this.$get('api/person/current').then((data) => {
        this.$store.dispatch('commitChangeType', data.userType);
        this.$store.dispatch('commitChangeUserId', data.id);
        this.getToDo();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getToDo() {
      this.$loadingShow();
      let userType;
      if (this.$store.state.userType == 0) {
        userType = 'FRONT_AGENDA_SUP'
      } else {
        userType = 'FRONT_AGENDA'
      }
      this.$search('/api/config-menu/find-by-code', {code: userType}).then(list => {
        // 暂时去除对账发票
        list = list.filter(i=>i.name !== '对账与发票')

        this.todoList = list;

        if (userType === 'FRONT_AGENDA') {
          this.todoList.forEach(val => {
            if(val.router && val.router.indexOf('/workflow/list/') > -1){
              let code = val.router.split('/workflow/list/')[1];
              val.wapRouter = `/dynamic-form-done?dynamicFormCode=${code}`;
              return;
            }
            if(val.router && val.router === '/pur-requisition/requisitionFlow'){
              //let code = '436775406756696064';
              //val.wapRouter = `/dynamic-form-done?dynamicFormCode=${code}`;
              val.wapRouter = `/dynamic-form-done?isRequisitionFlow=true`;
              return;
            }
            /**
             * 供应商管理
             */
            //供应商资料变更
            if (val.router === '/supplier-modify/deal') {
              val.wapRouter = '/sup/approval/pur-deal';
              return;
            }
            //新供应商资料审批
            if(val.router === '/sup-view/new-sup'){
              val.wapRouter = '/new-sup/approval';
              return;
            }
            //供应商绩效
            if (val.router === '/assess/backlog') {
              val.wapRouter = '/assess-report?tabIndex=2';
              return;
            }
            //资质到期
            if (val.router === '/qual-expired') {
              val.wapRouter = '/supplier-expires';
              return;
            }
            /**
             * 寻源管理
             */
            //待审核项目
            if (val.router === '/sources/deal') {
              val.wapRouter = '/source-approval/list';
              return;
            }
            //待评分项目
            if (val.router === '/sources-score/list/score?status=going') {
              val.wapRouter = '/source-scoring/list';
              return;
            }
            //待审核评分项目
            if (val.router === '/sources-score/list/check?status=going') {
              val.wapRouter = '/auditing-score/list';
              return;
            }
            /**
             * 采购执行
             */
            //索赔管理
            if (val.router === '/claim-management/claim-deal') {
              val.wapRouter = '/claim-management-list?tabIndex=2';
              return;
            }
            //采购订单
            if (val.router === '/purchase-order/screen') {
              val.wapRouter = '/purchase-order-confirm';
              return;
            }
            //要货计划
            if (val.router === '/cargo-plan/pending-disposal') {
              val.wapRouter = '/cargo-query-plan-todo';
              return;
            }
            //送货
            if (val.router === '/asn/todo-list') {
              val.wapRouter = '/asn-list';
              return;
            }
            //采购合同
            if (val.router === '/contract/contract-deal') {
              val.wapRouter = '/contract-query?tabIndex=2';
              return;
            }
            //采购申请待办
            if (val.router ===  "/pur-requisition/todo") {
              val.wapRouter = '/pur-requisition-todo-list';
              return;
            }

            if (val.router === '/contract/contract-deal') {
              val.wapRouter = '/contract-query?tabIndex=2';
              return;
            }
            //对账与发票 暂时隐藏
            // if (val.router === '/soa/soa-deal') {
            //   val.wapRouter = '/soa-list?tabIndex=2';
            //   return;
            // }
            //价格审批
            if (val.router === '/price-approval/deal') {
              val.wapRouter = '/price-approval-list?tabIndex=2';
              return;
            }
            if(val.router == "/order-approve/todo"){
              val.wapRouter = '/approval-agency';
              return;
            }
          });
        }
        if (userType === 'FRONT_AGENDA_SUP') {
          this.todoList.forEach(val => {
            val.isShow=true;
            if(val.router && val.router.indexOf('/workflow/list/') > -1){
              let code = val.router.split('/workflow/list/')[1];
              val.wapRouter = `/dynamic-form-done?dynamicFormCode=${code}`;
              return;
            }
            /**
             * 我的资质评定
             */
            //我的资质到期
            if (val.router === '/qual-expired') {
              val.wapRouter = '/supplier-expires';
              return;
            }
            /**
             * 我的合同和订单
             */
            //我的送货
            if (val.router === '/asn/todo-list') {
              val.wapRouter = '/asn-list?tabIndex=2';
              return;
            }
            //我的扣款
            if (val.router === '/claim-management/claim-deal') {
              val.wapRouter = '/claim-management-list?userType=0&tabIndex=2';
              return;
            }
            //我要对账 暂时隐藏
            // if (val.router === '/soa/soa-deal') {
            //   val.wapRouter = '/soa-list?tabIndex=2';
            //   return;
            // }
            //客户要货计划
            if (val.router === '/cargo-plan/pending-disposal') {
              val.wapRouter = '/cargo-query-plan-todo';
              return;
            }
            //采购订单
            if (val.router === '/purchase-order/screen-order-supplier') {
              val.wapRouter = '/purchase-order-confirm';
              return;
            }
            //采购合同
            if (val.router === '/contract/contract-deal') {
              val.wapRouter = '/contract-query?userType=0';
              return;
            }
            /**
             * 寻源
             */
            //寻源列表
            if (val.router === '/sources-sup/list/101' || val.router === '/sources-sup/list/101?status=going') {
              val.wapRouter = '/sup-sources-list/101';
              return;
            }
            if (val.router === '/sources-sup/list/102' || val.router === '/sources-sup/list/102?status=going') {
              val.wapRouter = '/sup-sources-list/102';
              return;
            }
            if (val.router === '/sources-sup/list/104' || val.router === '/sources-sup/list/104?status=going') {
              val.wapRouter = '/sup-sources-list/104';
              return;
            }
            if (val.router === '/sources-sup/list/105' || val.router === '/sources-sup/list/105?status=going') {
              val.wapRouter = '/sup-sources-list/105';
              return;
            }
            if (val.router === '/sources-sup/list/107' || val.router === '/sources-sup/list/107?status=going') {
              val.wapRouter = '/sup-sources-list/107';
              return;
            }
          });
        }
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    goToDo(item) {
    debugger;
      if (item.wapRouter) {
        if (this.$store.state.device === 'wap') {
          this.$router.push(item.wapRouter);
        } else {
          document.location = "http://action:10061/?url=" + appBaseUrl + item.wapRouter.substring(1) + "?device=" + this.$store.state.device + '&&hiddentitle=1';
        }
      } else {
        this.$vux.toast.text('手机端暂不支持处理该待办');
      }
    },
    //  跳转到个人设置页
    goUserSetting() {
      if (this.$store.state.device === 'wap') {
        this.$router.push('/home/mine');
      } else {
        document.location = "http://action:10061/?url=" + appBaseUrl + "home/mine?device=" + this.$store.state.device + '&&hiddentitle=1';
      }
    }
  },
  mounted() {
    this.getUserType();
  },
}



// WEBPACK FOOTER //
// ./src/page/home/toDo.vue